import React, { useEffect, useRef } from "react";

export default function Sol(props) {

    const { defaultValue,
        id,
        name,
        placeholder,
        onChange } = props;

    const selectEl = useRef(null);

    useEffect(() => {
        const $this = $(selectEl.current);
        const placeholder = $this.data('placeholder');

        $this.searchableOptionList({
            showSelectAll: false,
            showSelectionBelowList: true,
            texts: {
                searchplaceholder: placeholder
            },
            events: {
                onOpen: function (sol, items) {
                    const $select = $('.select-options');

                    $select.each(function (index, el) {
                        const $this = $(this);

                        const $containerWitdh = $this.find('.sol-container').width();
                        const $options = $this.find('.sol-selection-container');

                        $options.css({
                            width: $containerWitdh
                        });
                    });
                },
                onScroll: function () {
                    let posY = this.$input.offset().top - this.config.scrollTarget.scrollTop() + this.$input.outerHeight(),
                        selectionContainerWidth = this.$innerContainer.outerWidth(false) - parseInt(this.$selectionContainer.css('border-left-width'), 10) - parseInt(this.$selectionContainer.css('border-right-width'), 10);

                    this.$selectionContainer
                        .css('top', Math.floor(posY))
                }
            },
        });
        $this.on('change', onChange);

        return function cleanup() {
            $this.off('change', onChange);
        }
    }, []);

    return (
        <div>
            <select ref={selectEl} defaultValue={defaultValue} id={id} name={name} data-placeholder={placeholder}
                multiple="multiple">
                {props.children}
            </select>
        </div>
    );
}